import type { Source } from "./sseEvents";

/** Bare hostname (no leading `www.`) of a source URL, or null when unparseable. */
export function sourceHost(url: string): string | null {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return null;
  }
}

/** Favicon URL for a host, via Google's favicon service. */
export function faviconUrl(host: string): string {
  return `https://www.google.com/s2/favicons?sz=64&domain=${host}`;
}

/** Display label for a source: site name, else host, else the raw URL. */
export function sourceLabel(source: Source): string {
  return source.site_name || sourceHost(source.url) || source.url;
}
